import React from "react";
import { Route, RouteProps } from "../polyrouter";
import AppErrorBoundary from "./AppErrorBoundary";
import { ErrorPage } from "elements";

export const AppRoute: React.FC<Pick<RouteProps, "path" | "exact"> & {
  Component: React.ComponentType;
}> = ({ Component, ...props }) => {
  return (
    <Route {...props} trackAsParameterizedRoute>
      <AppErrorBoundary errorComponent={<ErrorPage />}>
        <Component />
      </AppErrorBoundary>
    </Route>
  );
};
export default AppRoute;
